import { useEffect } from "react";
function Welcome() {
  useEffect(function () {
    window.location.href = "/home.url";
  }, []);
}
Welcome.isPublic = true;
export default Welcome;